import { render, staticRenderFns } from "./healthManual_2021.vue?vue&type=template&id=ac133b7a&scoped=true&"
import script from "./healthManual_2021.vue?vue&type=script&lang=js&"
export * from "./healthManual_2021.vue?vue&type=script&lang=js&"
import style0 from "./healthManual_2021.vue?vue&type=style&index=0&id=ac133b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac133b7a",
  null
  
)

export default component.exports